const THREE = require("three");
export class Water extends THREE.Mesh {
  constructor(p7796, p7797 = {}) {
    super(p7796);
    this.isWater = true;
    const vThis52 = this;
    const v6540 = p7797.textureWidth !== undefined ? p7797.textureWidth : 512;
    const v6541 = p7797.textureHeight !== undefined ? p7797.textureHeight : 512;
    const v6542 = p7797.clipBias !== undefined ? p7797.clipBias : 0;
    const v6543 = p7797.alpha !== undefined ? p7797.alpha : 1;
    const v6544 = p7797.time !== undefined ? p7797.time : 0;
    const v6545 = p7797.waterNormals !== undefined ? p7797.waterNormals : null;
    const v6546 = p7797.sunDirection !== undefined ? p7797.sunDirection : new THREE.Vector3(0.70707, 0.70707, 0);
    const v6547 = new THREE.Color(p7797.sunColor !== undefined ? p7797.sunColor : 16777215);
    const v6548 = new THREE.Color(p7797.waterColor !== undefined ? p7797.waterColor : 8355711);
    const v6549 = p7797.eye !== undefined ? p7797.eye : new THREE.Vector3(0, 0, 0);
    const v6550 = p7797.distortionScale !== undefined ? p7797.distortionScale : 20;
    const v6551 = p7797.side !== undefined ? p7797.side : THREE.FrontSide;
    const v6552 = p7797.fog !== undefined ? p7797.fog : false;
    const v6553 = new THREE.Plane();
    const v6554 = new THREE.Vector3();
    const v6555 = new THREE.Vector3();
    const v6556 = new THREE.Vector3();
    const v6557 = new THREE.Matrix4();
    const v6558 = new THREE.Vector3(0, 0, -1);
    const v6559 = new THREE.Vector4();
    const v6560 = new THREE.Vector3();
    const v6561 = new THREE.Vector3();
    const v6562 = new THREE.Vector4();
    const v6563 = new THREE.Matrix4();
    const v6564 = new THREE.PerspectiveCamera();
    const v6565 = new THREE.WebGLRenderTarget(v6540, v6541);
    const vO194 = {
      uniforms: THREE.UniformsUtils.merge([THREE.UniformsLib.fog, THREE.UniformsLib.lights, {
        normalSampler: {
          value: null
        },
        mirrorSampler: {
          value: null
        },
        alpha: {
          value: 1
        },
        time: {
          value: 0
        },
        size: {
          value: 1
        },
        distortionScale: {
          value: 20
        },
        textureMatrix: {
          value: new THREE.Matrix4()
        },
        sunColor: {
          value: new THREE.Color(8355711)
        },
        sunDirection: {
          value: new THREE.Vector3(0.70707, 0.70707, 0)
        },
        eye: {
          value: new THREE.Vector3()
        },
        waterColor: {
          value: new THREE.Color(5592405)
        }
      }]),
      vertexShader: "\n\t\t\t\tuniform mat4 textureMatrix;\n\t\t\t\tuniform float time;\n\n\t\t\t\tvarying vec4 mirrorCoord;\n\t\t\t\tvarying vec4 worldPosition;\n\n\t\t\t\t#include <common>\n\t\t\t\t#include <fog_pars_vertex>\n\t\t\t\t#include <shadowmap_pars_vertex>\n\t\t\t\t#include <logdepthbuf_pars_vertex>\n\n\t\t\t\tvoid main() {\n\t\t\t\t\tmirrorCoord = modelMatrix * vec4( position, 1.0 );\n\t\t\t\t\tworldPosition = mirrorCoord.xyzw;\n\t\t\t\t\tmirrorCoord = textureMatrix * mirrorCoord;\n\t\t\t\t\tvec4 mvPosition =  modelViewMatrix * vec4( position, 1.0 );\n\t\t\t\t\tgl_Position = projectionMatrix * mvPosition;\n\n\t\t\t\t#include <beginnormal_vertex>\n\t\t\t\t#include <defaultnormal_vertex>\n\t\t\t\t#include <logdepthbuf_vertex>\n\t\t\t\t#include <fog_vertex>\n\t\t\t\t#include <shadowmap_vertex>\n\t\t\t}",
      fragmentShader: "\n\t\t\t\tuniform sampler2D mirrorSampler;\n\t\t\t\tuniform float alpha;\n\t\t\t\tuniform float time;\n\t\t\t\tuniform float size;\n\t\t\t\tuniform float distortionScale;\n\t\t\t\tuniform sampler2D normalSampler;\n\t\t\t\tuniform vec3 sunColor;\n\t\t\t\tuniform vec3 sunDirection;\n\t\t\t\tuniform vec3 eye;\n\t\t\t\tuniform vec3 waterColor;\n\n\t\t\t\tvarying vec4 mirrorCoord;\n\t\t\t\tvarying vec4 worldPosition;\n\n\t\t\t\tvec4 getNoise( vec2 uv ) {\n\t\t\t\t\tvec2 uv0 = ( uv / 103.0 ) + vec2(time / 17.0, time / 29.0);\n\t\t\t\t\tvec2 uv1 = uv / 107.0-vec2( time / -19.0, time / 31.0 );\n\t\t\t\t\tvec2 uv2 = uv / vec2( 8907.0, 9803.0 ) + vec2( time / 101.0, time / 97.0 );\n\t\t\t\t\tvec2 uv3 = uv / vec2( 1091.0, 1027.0 ) - vec2( time / 109.0, time / -113.0 );\n\t\t\t\t\tvec4 noise = texture2D( normalSampler, uv0 ) +\n\t\t\t\t\t\ttexture2D( normalSampler, uv1 ) +\n\t\t\t\t\t\ttexture2D( normalSampler, uv2 ) +\n\t\t\t\t\t\ttexture2D( normalSampler, uv3 );\n\t\t\t\t\treturn noise * 0.5 - 1.0;\n\t\t\t\t}\n\n\t\t\t\tvoid sunLight( const vec3 surfaceNormal, const vec3 eyeDirection, float shiny, float spec, float diffuse, inout vec3 diffuseColor, inout vec3 specularColor ) {\n\t\t\t\t\tvec3 reflection = normalize( reflect( -sunDirection, surfaceNormal ) );\n\t\t\t\t\tfloat direction = max( 0.0, dot( eyeDirection, reflection ) );\n\t\t\t\t\tspecularColor += pow( direction, shiny ) * sunColor * spec;\n\t\t\t\t\tdiffuseColor += max( dot( sunDirection, surfaceNormal ), 0.0 ) * sunColor * diffuse;\n\t\t\t\t}\n\n\t\t\t\t#include <common>\n\t\t\t\t#include <packing>\n\t\t\t\t#include <bsdfs>\n\t\t\t\t#include <fog_pars_fragment>\n\t\t\t\t#include <logdepthbuf_pars_fragment>\n\t\t\t\t#include <lights_pars_begin>\n\t\t\t\t#include <shadowmap_pars_fragment>\n\t\t\t\t#include <shadowmask_pars_fragment>\n\n\t\t\t\tvoid main() {\n\n\t\t\t\t\t#include <logdepthbuf_fragment>\n\t\t\t\t\tvec4 noise = getNoise( worldPosition.xz * size );\n\t\t\t\t\tvec3 surfaceNormal = normalize( noise.xzy * vec3( 1.5, 1.0, 1.5 ) );\n\n\t\t\t\t\tvec3 diffuseLight = vec3(0.0);\n\t\t\t\t\tvec3 specularLight = vec3(0.0);\n\n\t\t\t\t\tvec3 worldToEye = eye-worldPosition.xyz;\n\t\t\t\t\tvec3 eyeDirection = normalize( worldToEye );\n\t\t\t\t\tsunLight( surfaceNormal, eyeDirection, 100.0, 2.0, 0.5, diffuseLight, specularLight );\n\n\t\t\t\t\tfloat distance = length(worldToEye);\n\n\t\t\t\t\tvec2 distortion = surfaceNormal.xz * ( 0.001 + 1.0 / distance ) * distortionScale;\n\t\t\t\t\tvec3 reflectionSample = vec3( texture2D( mirrorSampler, mirrorCoord.xy / mirrorCoord.w + distortion ) );\n\n\t\t\t\t\tfloat theta = max( dot( eyeDirection, surfaceNormal ), 0.0 );\n\t\t\t\t\tfloat rf0 = 0.3;\n\t\t\t\t\tfloat reflectance = rf0 + ( 1.0 - rf0 ) * pow( ( 1.0 - theta ), 5.0 );\n\t\t\t\t\tvec3 scatter = max( 0.0, dot( surfaceNormal, eyeDirection ) ) * waterColor;\n\t\t\t\t\tvec3 albedo = mix( ( sunColor * diffuseLight * 0.3 + scatter ) * getShadowMask(), ( vec3( 0.1 ) + reflectionSample * 0.9 + reflectionSample * specularLight ), reflectance);\n\t\t\t\t\tvec3 outgoingLight = albedo;\n\t\t\t\t\tgl_FragColor = vec4( outgoingLight, alpha );\n\n\t\t\t\t\t#include <tonemapping_fragment>\n\t\t\t\t\t#include <fog_fragment>\n\t\t\t\t}"
    };
    const v6566 = new THREE.ShaderMaterial({
      fragmentShader: vO194.fragmentShader,
      vertexShader: vO194.vertexShader,
      uniforms: THREE.UniformsUtils.clone(vO194.uniforms),
      lights: true,
      side: v6551,
      fog: v6552
    });
    v6566.uniforms.mirrorSampler.value = v6565.texture;
    v6566.uniforms.textureMatrix.value = v6563;
    v6566.uniforms.alpha.value = v6543;
    v6566.uniforms.time.value = v6544;
    v6566.uniforms.normalSampler.value = v6545;
    v6566.uniforms.sunColor.value = v6547;
    v6566.uniforms.waterColor.value = v6548;
    v6566.uniforms.sunDirection.value = v6546;
    v6566.uniforms.distortionScale.value = v6550;
    v6566.uniforms.eye.value = v6549;
    vThis52.material = v6566;
    vThis52.onBeforeRender = function (p7798, p7799, p7800) {
      v6555.setFromMatrixPosition(vThis52.matrixWorld);
      v6556.setFromMatrixPosition(p7800.matrixWorld);
      v6557.extractRotation(vThis52.matrixWorld);
      v6554.set(0, 0, 1);
      v6554.applyMatrix4(v6557);
      v6560.subVectors(v6555, v6556);
      if (v6560.dot(v6554) > 0) {
        return;
      }
      v6560.reflect(v6554).negate();
      v6560.add(v6555);
      v6557.extractRotation(p7800.matrixWorld);
      v6558.set(0, 0, -1);
      v6558.applyMatrix4(v6557);
      v6558.add(v6556);
      v6561.subVectors(v6555, v6558);
      v6561.reflect(v6554).negate();
      v6561.add(v6555);
      v6564.position.copy(v6560);
      v6564.up.set(0, 1, 0);
      v6564.up.applyMatrix4(v6557);
      v6564.up.reflect(v6554);
      v6564.lookAt(v6561);
      v6564.far = p7800.far;
      v6564.updateMatrixWorld();
      v6564.projectionMatrix.copy(p7800.projectionMatrix);
      v6563.set(0.5, 0, 0, 0.5, 0, 0.5, 0, 0.5, 0, 0, 0.5, 0.5, 0, 0, 0, 1);
      v6563.multiply(v6564.projectionMatrix);
      v6563.multiply(v6564.matrixWorldInverse);
      v6553.setFromNormalAndCoplanarPoint(v6554, v6555);
      v6553.applyMatrix4(v6564.matrixWorldInverse);
      v6559.set(v6553.normal.x, v6553.normal.y, v6553.normal.z, v6553.constant);
      const v6567 = v6564.projectionMatrix;
      v6562.x = (Math.sign(v6559.x) + v6567.elements[8]) / v6567.elements[0];
      v6562.y = (Math.sign(v6559.y) + v6567.elements[9]) / v6567.elements[5];
      v6562.z = -1;
      v6562.w = (1 + v6567.elements[10]) / v6567.elements[14];
      v6559.multiplyScalar(2 / v6559.dot(v6562));
      v6567.elements[2] = v6559.x;
      v6567.elements[6] = v6559.y;
      v6567.elements[10] = v6559.z + 1 - v6542;
      v6567.elements[14] = v6559.w;
      v6549.setFromMatrixPosition(p7800.matrixWorld);
      const v6568 = p7798.getRenderTarget();
      const v6569 = p7798.xr.enabled;
      const v6570 = p7798.shadowMap.autoUpdate;
      vThis52.visible = false;
      p7798.xr.enabled = false;
      p7798.shadowMap.autoUpdate = false;
      p7798.setRenderTarget(v6565);
      p7798.state.buffers.depth.setMask(true);
      if (p7798.autoClear === false) {
        p7798.clear();
      }
      p7798.render(p7799, v6564);
      vThis52.visible = true;
      p7798.xr.enabled = v6569;
      p7798.shadowMap.autoUpdate = v6570;
      p7798.setRenderTarget(v6568);
      const v6571 = p7800.viewport;
      if (v6571 !== undefined) {
        p7798.state.viewport(v6571);
      }
    };
  }
}